import React, {Component} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup} from "semantic-ui-react"

import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import queryString from "qs"

@observer
export default class CartButton extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0
		}
	}

	render() {
		let {sum, loading} = shop.cart
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (sum > shop.config.MIN_ORDER_VALUE)

		if ( !shop.session ) return null

		const isMobile = window.innerWidth <= 768
		const buttonStyle = {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			background: "#917236",
			position: "relative",
			boxShadow: "inset 0 8px 12px rgba(255,255,255,0.05), inset 0 -8px 12px rgba(0,0,0,0.3)",
			borderTop: "1px solid rgba(255,255,255,0.1)",
			borderBottom: "1px solid rgba(0,0,0,0.5)",
			color: "white",
			height: "40px",
			width: isMobile ? "60px" : "120px",
			borderRadius: "0px",
			fontSize: "18px",
			transition: "filter 300ms",
		}

		return (
			<div className="CartButton relative">
				<Button
					style={buttonStyle}
					loading={loading}
					className="CartButtonItem cssOptima"
					{...this.props}
					as={Link}
					to={{
						pathname: `/checkout/`,
						search  : queryString.stringify( {referer: document.location.pathname} )
					}}
					onMouseOver={e => e.currentTarget.style.filter = "brightness(0.9)"}
					onMouseOut={e => e.currentTarget.style.filter = ""}
				>
					<Popup trigger={
						<React.Fragment>
							{aboveMin ? <Icon name="shopping cart" /> : <Icon name={"warning circle"} />}
							{sum > 0 ? <Price className="f5 fw6">{sum}</Price> : <span><Price>0</Price></span>}
						</React.Fragment>
					}>

						<div>
							{!!MIN_ORDER_VALUE && <span>{translate( "min_order_value" )} <Price>{shop.config.MIN_ORDER_VALUE}</Price></span>}
							{(!MIN_ORDER_VALUE) && <span>Warenkorb anzeigen</span>}
						</div>
					</Popup>
				</Button>
				<div className="absolute left-0 right-0 MinOrderValue-container">
					<MinOrderValue sum={sum} />
				</div>
			</div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Cart/CartButton.js